document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.mySwiper');

  if (swiperEl) {
    const swiper = new Swiper(".mySwiper", {
      effect: "coverflow",
      grabCursor: false,
      centeredSlides: true,
      slidesPerView: "auto",
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      allowTouchMove: window.innerWidth <= 768, // Disable swipe on desktop
    });

    // Update allowTouchMove on resize
    window.addEventListener('resize', () => {
      swiper.allowTouchMove = window.innerWidth <= 768;
    });

    // Clicking on non-active slide moves forward/back like Revolut
    swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
      slide.addEventListener('click', function () {
        if (slide.classList.contains('swiper-slide-prev')) {
          swiper.slidePrev();
        } else if (slide.classList.contains('swiper-slide-next')) {
          swiper.slideNext();
        }
      });
    });
  }
});
